import { MultiMedia } from "../hoardings/multiMedia";

export class PurchaseOrder extends MultiMedia {
    po: boolean = false;
    poNumber: string;
    poDate: Date;
    updatedBy: string;
}
